import React from 'react';

const STATUS_CONFIG = {
  open: { label: 'Novi', className: 'bg-blue-100 text-blue-700 border border-blue-200' },
  in_mediation: { label: 'U medijaciji', className: 'bg-amber-100 text-amber-700 border border-amber-200' },
  mediator_assigned: { label: 'Mediator dodeljen', className: 'bg-purple-100 text-purple-700 border border-purple-200' },
  resolved: { label: 'Rešen', className: 'bg-emerald-100 text-emerald-700 border border-emerald-200' },
  escalated: { label: 'Eskalovan', className: 'bg-red-100 text-red-700 border border-red-200' },
  closed: { label: 'Zatvoren', className: 'bg-gray-100 text-gray-600 border border-gray-200' },
};

const DisputeStatusBadge = ({ status }) => {
  const config = STATUS_CONFIG?.[status] || { label: status || 'Nepoznat', className: 'bg-gray-100 text-gray-600 border border-gray-200' };
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold ${config?.className}`}>
      {config?.label}
    </span>
  );
};

export default DisputeStatusBadge;
